import { compareAsc, endOfDay, max } from "date-fns";
import { filter, find, flatten, reduce, some } from "lodash";
import numbro from "numbro";
import {
    PaymentRequestStatus,
    PaymentStatus,
} from "../../PaymentContainerClient/commons/enums";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";
import PaymentMethodConstraintsDto from "../../PaymentContainerClient/dtos/PaymentMethodConstraintsDto";
import PaymentRequestDto from "../../PaymentContainerClient/dtos/PaymentRequestDto";

export const getDeadline = (paymentRequest: PaymentRequestDto): Date => {
    // Warning: understand what should be done when there will be the debtor
    // chosen amount payment plan and the other plans..
    const chosenPlanId = find(paymentRequest.payments, {
        status: PaymentStatus.Paid,
    })?.paymentPlanId;

    const filteredPaymentPlans = chosenPlanId
        ? filter(paymentRequest.availablePaymentPlans, { id: chosenPlanId })
        : paymentRequest.availablePaymentPlans;

    const installmentsDueDates = flatten(
        filteredPaymentPlans.map((paymentPlan) => paymentPlan.installments)
    ).map((installment) => new Date(installment.dueDate));

    return max(installmentsDueDates);
};

export const hasAllPaymentsExpired = (
    paymentRequest: PaymentRequestDto
): boolean => {
    const deadline = getDeadline(paymentRequest);
    return (
        compareAsc(new Date(), endOfDay(deadline)) === 1 &&
        paymentRequest.status !== PaymentRequestStatus.Paid
    );
};

export const hasExpired = (paymentRequest: PaymentRequestDto): boolean => {
    return (
        compareAsc(new Date(), endOfDay(new Date(paymentRequest.dueDate))) === 1
    );
};

export const getTotalPaid = (payments: PaymentDto[]): number => {
    return reduce(
        payments,
        (result, payment) => {
            return numbro(result)
                .add(
                    payment.status === PaymentStatus.Paid ||
                        payment.status === PaymentStatus.ExternalPaid
                        ? parseFloat(payment.amount.amount)
                        : 0
                )
                .value();
        },
        0
    );
};

export const getTotalRemaining = (
    totalAmount: string,
    payments: PaymentDto[]
): number => {
    const totalPaid = getTotalPaid(payments);
    return numbro(totalAmount).subtract(totalPaid).value();
};

export const isInConstraintsRange = (
    amount: string,
    constraints?: PaymentMethodConstraintsDto
): boolean => {
    return (
        (!constraints?.minimumAmount ||
            numbro(amount).value() >=
                numbro(constraints.minimumAmount.amount).value()) &&
        (!constraints?.maximumAmount ||
            numbro(amount).value() <=
                numbro(constraints.maximumAmount.amount).value())
    );
};

export const isInAtLeastOnePaymentMethodConstraintsRange = (
    amount: string,
    paymentRequest: PaymentRequestDto
): boolean => {
    return some(paymentRequest.availablePaymentMethods, (paymentMethod) =>
        isInConstraintsRange(amount, paymentMethod.constraints)
    );
};
